import { get, postFormData } from 'utils/methods';

export function addNewImportApi(data, headers) {
    return postFormData(`${process.env.REACT_APP_REST}commands/import`, data, headers);
}

export function getImportsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}imported-files`, data, headers);
}
